import React, { useEffect } from "react";
import { useScrollManager } from "../useScrollManager/useScrollManager";

export const useRegister = (
  target: React.RefObject<HTMLDivElement | null>,
  index: number
) => {
  const { intersectionMap } = useScrollManager();

  useEffect(() => {
    const im = intersectionMap.current;
    im.set(index, { ref: target, intersecting: false });

    const observer = new IntersectionObserver(
      (entries) => {
        const item = im.get(index);

        if (item) {
          item.intersecting = entries[0].isIntersecting;
        }
      },
      {
        threshold: 1,
      }
    );
    observer.observe(target.current as Element);

    return () => {
      im.delete(index);
      observer.disconnect();
    };
  }, [target, index, intersectionMap]);
};
